/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'marker': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M33.943 21.17c0 1.761-.367 3.677-1.454 5.401-3.276 5.087-7.422 9.756-7.422 9.756s-4.767-4.505-7.812-9.848c-.763-1.667-1.262-3.432-1.262-5.199 0-4.967 4.017-9.281 8.975-9.281 4.958.001 8.975 4.205 8.975 9.171zm-3.528-.363a5.365 5.365 0 0 0-5.366-5.367 5.364 5.364 0 0 0-5.366 5.367 5.365 5.365 0 0 0 5.366 5.365c2.963 0 5.366-2.4 5.366-5.365z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/marker.js